var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "font-italic"
  }, [_c('div', [_c('div', {
    staticClass: "before"
  }), _c('span', {
    staticClass: "preserve-newlines",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _c('div', {
    staticClass: "after"
  })]), _c('div', {
    staticClass: "my-3 d-flex flex-grow-1"
  }, [_c('div', {
    staticClass: "flex-grow-0 my-3"
  }, [_vm._v("–")]), _c('div', {
    staticClass: "flex-grow-1 d-sm-flex align-end"
  }, [_c('div', {
    staticClass: "flex-grow-1 ma-3 mb-2"
  }, [_vm._v(" " + _vm._s(_vm.name) + " "), _c('div', {
    staticClass: "text--label-active"
  }, [_vm._v(" " + _vm._s(_vm.role)), _vm.role && _vm.company ? [_vm._v(", ")] : _vm._e(), _vm._v(_vm._s(_vm.company) + " ")], 2)]), _c('div', {
    staticClass: "flex-grow-0 text-right mb-2 mx-n2"
  }, [_c('v-btn', _vm._b({
    staticClass: "d-inline-flex align-center pa-2",
    staticStyle: {
      "height": "40px",
      "min-width": "unset"
    },
    attrs: {
      "large": "",
      "text": ""
    }
  }, 'v-btn', _vm.link ? {
    target: '_blank',
    href: _vm.link
  } : {}, false), [_vm.src == 'Capterra' ? _c('img', {
    attrs: {
      "height": "24",
      "loading": "lazy",
      "src": require("../assets/capterra.svg")
    }
  }) : _vm.src == 'Google' ? _c('img', {
    attrs: {
      "height": "24",
      "loading": "lazy",
      "src": require("../assets/g-logo.png")
    }
  }) : _vm.src == 'Trustpilot' ? _c('img', {
    attrs: {
      "height": "24",
      "loading": "lazy",
      "src": require("../assets/trustpilot-dark.svg")
    }
  }) : _vm._e(), _vm.src ? [_c('v-icon', {
    staticClass: "ml-3",
    attrs: {
      "color": "primary"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiOpenInNew)
    }
  }), _c('span', {
    staticClass: "btn-tooltip bottom left"
  }, [_vm._v("Full review by " + _vm._s(_vm.name) + " on " + _vm._s(_vm.src))])] : _vm._e()], 2)], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }